<template>
    <div class="story-card-flex d-flex align-items-stretch p-4 border-bottom" style="cursor: pointer" @click="$router.push({ name: 'story', query: { id: story.story_id, title: story.story_title, author: story.story_author.name }})">
        <div class="story-card-flex-image-container d-flex">
            <img class="card-image img font-sm align-self-center mx-auto rounded" :src="'/image/' + getImageId" @error="$root.imageAlt" alt="" />
        </div>
        <div class="story-card-flex-details-container d-flex flex-wrap justify-content-between">
            <!-- details for carousel, hidden on full size -->
            <div class="story-card-flex-details-short col-12 p-0">
                <span class="font-weight-bolder" v-text="getTitle"></span>
                <span class="text-dark-grey" v-text="getDescription"></span>
            </div>

            <!-- details on full size, hidden on carousel -->
            <div class="story-card-flex-details-long col-12 p-0">
                <div class="story-card-flex-title font-md font-weight-bolder" v-text="getTitle"></div>
                <div class="story-card-flex-short-desc font-sm text-dark-grey" v-text="getDescription"></div>
            </div>

            <div class="col-12 p-0 align-self-end position-static">
                <!-- Publushed Date -->
                <div class="font-xxs text-dark-grey d-inline-block">&#128340; {{ getPublishDate }}</div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {

        props: ["story"],

        computed: {
            getDescription() {
                return this.story.story_description
            },
            getImageId() {
                return this.story.imageId
            },
            getPublishDate(){
                let result = new Date(this.story.publishDate)
                return result.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"})
            },
            getTitle() {
                return this.story.story_title
            },
        },
    }
</script>
